module.exports = __webpack_public_path__ + "static/media/IconAppealingInactive.a423f96a.svg";